// How a cell is rendered is decided by the `type` the server put in the
// registry, so a new column needs no frontend change.

let currency = "SEK";
let locale = "sv-SE";
let timeZone = "Europe/Stockholm";

export function configureFormatting(opts: { currency?: string; locale?: string; timeZone?: string }) {
  if (opts.currency) currency = opts.currency;
  if (opts.locale) locale = opts.locale === "sv" ? "sv-SE" : opts.locale;
  if (opts.timeZone) timeZone = opts.timeZone;
}

export function getTimeZone() {
  return timeZone;
}

/** Amounts are whole units (kronor), not minor units — see the Rails models. */
export function money(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat(locale, {
    style: "currency", currency, maximumFractionDigits: 0,
  }).format(value);
}

export function number(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat(locale).format(value);
}

// Always render in the tenant's zone, never the operator's browser: a console
// used from another country must still show the times the garage sees.
export function dateTime(value: string | null | undefined): string {
  if (!value) return "—";
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "short", timeStyle: "short", timeZone,
  }).format(new Date(value));
}

export function dateOnly(value: string | null | undefined): string {
  if (!value) return "—";
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeZone }).format(new Date(value));
}

export function relative(value: string | null | undefined): string {
  if (!value) return "—";
  const diff = Date.now() - new Date(value).getTime();
  const mins = Math.round(diff / 60000);
  if (mins < 1) return "nyss";
  if (mins < 60) return `${mins} min sedan`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} h sedan`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} d sedan`;
  return dateOnly(value);
}

export function percent(value: number | null): string {
  if (value === null || value === undefined) return "—";
  return `${value > 0 ? "+" : ""}${value}%`;
}
